// four cards slider
const swiperCards = new Swiper(".cards__slider", {
  loop: false,
  spaceBetween: 0,
  slidesPerView: "auto",
  speed: 800,
  watchSlidesProgress: true,
  pagination: {
    el: ".cards-pagination",
    clickable: true,
  },
  navigation: {
    nextEl: ".cards-next",
    prevEl: ".cards-prev",
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: false,
  },
});
